import React from 'react'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { description, title } from '../../../constants/activity-seo'
/* import previewImg from '../../../assets/images/preview.png'
import imagenPreview from '@/assets/images/img-signed.webp' */
import SEO from '../../../shared/seo'
/* var seoPrinted = false */
const canonicalUrl = siteUrl + '/magazin/loving/'
export default function AppSEO() {
  /* if (seoPrinted) {
    return null
  } */

  /* seoPrinted = true */
  return (
    <>
      <SEO
        title={title}
        description={description}
        image={canonicalUrl + 'image-promo.png'}
        url={canonicalUrl}
        meta={[
          {
            property: 'og:site_name',
            content: 'Nosotras Certificado Yó firme para romper el silencio',
          },
          { property: 'og:image:width', content: '1080px' },
          { property: 'og:image:height', content: '1350px' },
        ]}
      />
    </>
  )
}
